export const OPTHINES = {
  voteName: '2020project/2020solicitationactivities',
  mustSearch: 'Button',
  buttonBg: '#4d9a46',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: '#589e49',
    inactiveBgColor: '#8abd56',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: '/2020-eat-with-good-manner/First',
    },
    {
      tabName: '我要投稿',
      tabPath: '/2020-eat-with-good-manner/User',
    },
  ],
  Grades: [
    '一年级',
    '二年级',
    '三年级',
    '四年级',
    '五年级',
    '六年级',
    '初一',
    '初二',
    '初三',
    '高一',
    '高二',
    '高三',
    '大一',
    '大二',
    '大三',
    '大四',
  ],
};
